import React from "react";
import { motion } from "framer-motion";

const AnimatedGradientText = ({ text }) => {
  return (
    <motion.span
      className="mytechprofileproject-animated-gradient"
      style={{
        background: "linear-gradient(90deg, purple, violet, #C13584, orange)",
        backgroundSize: "200% 200%",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
      animate={{
        backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
      }}
      transition={{
        duration: 4,
        ease: "easeInOut",
        repeat: Infinity,
      }}
    >
      {text}
    </motion.span>
  );
};

export default AnimatedGradientText;
